import { TenantTools } from './user/enums';
import { UserWithPermissions } from './user';

type RequestmanagerAccess = {
    canAccessRequestManager: boolean;
    hasInternalRequestManagerPermission?: boolean;
    tenantHasRMToolAccess: boolean;
};

export const userHasToolAccess = (user: UserWithPermissions, tool: TenantTools): boolean => {
    return (user.tenantTools ?? []).includes(tool);
};

export const userHasRequestManagerAccess = (
    user: UserWithPermissions,
    hasInternalRequestManagerPermission: boolean,
    strictCheck = false
): RequestmanagerAccess => {
    if (strictCheck) {
        // this is the new logic that will be enforced going forward
        const tenantHasRMToolAccess = userHasToolAccess(user, TenantTools.REQUEST_MANAGER);

        if (user.isTrueDatavanter) {
            return {
                canAccessRequestManager: hasInternalRequestManagerPermission && tenantHasRMToolAccess,
                hasInternalRequestManagerPermission,
                tenantHasRMToolAccess,
            };
        }

        return {
            canAccessRequestManager: tenantHasRMToolAccess,
            tenantHasRMToolAccess,
        };
    }
    // legacy logic - to be removed in the future
    const generalRule = user.isDatavanter && user.isProviderUser;
    return {
        canAccessRequestManager: generalRule || userHasToolAccess(user, TenantTools.REQUEST_MANAGER),
        tenantHasRMToolAccess: generalRule,
    };
};
